export default "__VITE_ASSET__qk16lxWO__"